import {
  Card,
  Dialog,
  InlineFormattedNumber,
  Stack,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  type UseDisclosureWithContextReturn,
  useSecuritiesContext,
} from '@talos/kyoko';
import type { FixingPriceWarning } from './utils';

export const FixingPriceWarningDialog = ({
  onConfirm,
  context: warnings,
  ...dialogProps
}: UseDisclosureWithContextReturn<FixingPriceWarning[]> & { onConfirm: () => void }) => {
  const { securitiesBySymbol } = useSecuritiesContext();

  return (
    <Dialog
      {...dialogProps}
      onConfirm={onConfirm}
      cancelLabel="No"
      confirmLabel="Yes"
      onCancel={() => dialogProps.close()}
      width={420}
      stretchButtons
      title="Fixing Price Warning"
      data-testid="apply-fixing-mid-price-warning-dialog"
    >
      {warnings == null ? null : (
        <Stack gap="spacing12">
          <Text textAlign="left">
            Some provided fixing prices are more than 5% away from the current mid price. Are you sure you want to
            continue?
          </Text>

          <Card>
            <Table data-testid="fixing-price-warnings-table">
              <Thead>
                <Tr>
                  <Th>Symbol</Th>
                  <Th align="right">Fixing</Th>
                  <Th align="right">Mid Price</Th>
                </Tr>
              </Thead>

              <Tbody>
                {warnings.map(warning => {
                  const security = securitiesBySymbol.get(warning.symbol);
                  return (
                    <Tr key={warning.symbol}>
                      <Td>{security?.DisplaySymbol ?? warning.symbol}</Td>
                      <Td align="right">
                        <InlineFormattedNumber number={warning.fixing} currency={security?.QuoteCurrency} />
                      </Td>
                      <Td align="right">
                        <InlineFormattedNumber number={warning.mid} currency={security?.QuoteCurrency} />
                      </Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </Card>
        </Stack>
      )}
    </Dialog>
  );
};
